export const common = {
  "cancel": "ยกเลิก",
  "close": "ปิด",
  "save": "บันทึก",
  "saving": "กำลังบันทึก...",
  "edit": "แก้ไข",
  "delete": "ลบ",
  "actions": "การกระทำ",
  "status": "สถานะ",
  "active": "ใช้งาน",
  "inactive": "ไม่ใช้งาน",
  "name": "ชื่อ",
  "email": "อีเมล",
  "role": "ตำแหน่ง",
  "pin": "PIN",
  "sku": "SKU",
  "price": "ราคา",
  "stock": "สต็อก",
  "category": "หมวดหมู่",
  "subtotal": "ยอดรวม",
  "discount": "ส่วนลด",
  "tax": "ภาษี",
  "total": "ยอดสุทธิ"
};
